import React from "react";
import { ApplyProvider } from "@/context/ApplyContext";
import { Header } from "@/components/landing/Header";
import { StickyMobileCta } from "@/components/landing/StickyMobileCta";
import { Hero } from "@/components/landing/Hero";
import { Testimonials } from "@/components/landing/Testimonials";
import { Problem } from "@/components/landing/Problem";
import { Epiphany } from "@/components/landing/Epiphany";
import { Outcomes } from "@/components/landing/Outcomes";
import { Coach } from "@/components/landing/Coach";
import { Offer } from "@/components/landing/Offer";
import { Delivery } from "@/components/landing/Delivery";
import { Bonuses } from "@/components/landing/Bonuses";
import { Scarcity } from "@/components/landing/Scarcity";
import { WhoFor } from "@/components/landing/WhoFor";
import { Guarantee } from "@/components/landing/Guarantee";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Waitlist } from "@/components/landing/Waitlist";

export default function LandingPage() {
  return (
    <ApplyProvider>
      <div className="min-h-screen bg-white text-zinc-900 antialiased" data-testid="landing-page">
        <Header />
        <main>
          <Hero />
          <Testimonials />
          <Problem />
          <Epiphany />
          <Outcomes />
          <Coach />
          <Offer />
          <Delivery />
          <Bonuses />
          <Scarcity />
          <WhoFor />
          <Guarantee />
          <Faq />
          <FinalCta />
          <Waitlist />
        </main>
        <StickyMobileCta />
      </div>
    </ApplyProvider>
  );
}
